const zhLang = {
  header: {
    setting: '设置',
    fullScreen: '全屏',
    exitFullscreen: '退出全屏',
    userCenter: '个人中心',
    logout: '退出账号',
    langLabel: '语言',
    zhTip: '中文',
    enTip: '英语',
  },
  button: {
    searchText: '搜索'
  },
}

export default zhLang
